<template>
    <v-row class="fiscalContactForm">
        <!--<div class="d-flex align-center">
            <v-card-subtitle class="font-weight-bold">
                ¿Deseas utilizar los mismos datos con los que te registraste en la ventanilla?
            </v-card-subtitle>
            <v-switch
                v-model="useNameOfContact"
                inset
                :label="useNameOfContact ? 'Si' : 'No'"
                class="mt-0"
                @change="useProcedureContact()"
            ></v-switch>
        </div>-->
        <v-col cols="12"  class="padding-bottom-none">
            <label for="" class="label-form ">RFC</label>
            <v-text-field
                outlined required v-model="fiscalContact.rfc"
                placeholder="Ingresa una RFC válida"
                :rules="[formValidator.rfc.validate, formValidator.input.required]"
                class="pb-0"
                @keyup="validateRFC()"
            />
        </v-col>
        <v-col cols="12"  class="padding-bottom-none">
            <label for="" class="label-form ">Régimen Fiscal</label>
            <v-select
                outlined required="selected"
                :items="regimen"
                item-text="descripcion"
                item-value="clave"
                v-model="fiscalContact.regimen_id"
                :rules="[formValidator.input.required]"
            ></v-select>
        </v-col>
        <v-col cols="12" v-if="moralPerson" class="padding-bottom-none">
            <label for="" class="label-form ">Razón Social</label>
            <v-text-field
                    outlined required v-model="fiscalContact.razon_social"
                    :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="12" class="padding-bottom-none" v-if="!moralPerson">
            <label for="" class="label-form ">Nombre(s)/Razón social</label>
            <v-text-field
                outlined required v-model="fiscalContact.nombre"
                :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="12" class="padding-bottom-none" v-if="!moralPerson">
            <label for="" class="label-form ">Primer apellido</label>
            <v-text-field
                outlined required v-model="fiscalContact.apellido_pat"

            />
        </v-col>
        <v-col cols="12" v-if="!moralPerson" class="padding-bottom-none">
            <label for="" class="label-form ">Segundo apellido</label>
            <v-text-field
                outlined required v-model="fiscalContact.apellido_mat"
            />
        </v-col>
        <v-col cols="12">
            <label>{{ this.fullName }}</label>
        </v-col>
        <!--<v-col cols="6">
            <label for="" class="label-form ">Calle</label>
            <v-text-field
                outlined required v-model="fiscalContact.calle"
            />
        </v-col>
        <v-col cols="3">
            <label for="" class="label-form ">Num Exterior</label>
            <v-text-field
                outlined required v-model="fiscalContact.no_ext"
            />
        </v-col>
        <v-col cols="3">
            <label for="" class="label-form ">Num Interior</label>
            <v-text-field
                outlined required v-model="fiscalContact.no_int"
            />
        </v-col>
        <v-col cols="6">
            <label for="" class="label-form ">Estado</label>
            <v-select
                :items="states"
                item-value="cve_agee"
                item-text="nom_agee"
                v-model="fiscalContact.estado_id"
                required
                outlined
                @change="onStateSelectChange()"
            ></v-select>
        </v-col>
        <v-col cols="6">
            <label for="" class="label-form ">Municipio</label>
            <v-select
                :items="municipalities"
                item-value="cve_agem"
                item-text="nom_agem"
                v-model="fiscalContact.municipio_id"
                required
                outlined
                @change="onMunicipalitySelectChange()"
            ></v-select>
        </v-col>
        <v-col cols="6">
            <label for="" class="label-form ">Colonia</label>
            <v-select
                :items="neighborhoods"
                item-value="nom_asen"
                item-text="nom_asen"
                v-model="fiscalContact.colonia"
                required
                outlined
            ></v-select>
        </v-col>-->
        <v-col cols="6" class="padding-bottom-none">
            <label for="" class="label-form ">Código Postal</label>
            <v-text-field
                outlined required v-model="fiscalContact.codigo_postal"
                :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="6" class="padding-bottom-none">

        </v-col>
        <v-col cols="6" class="padding-bottom-none">
            <label for="" class="label-form ">Teléfono</label>
            <v-text-field v-if="validRFC"
                outlined required v-model="fiscalContact.telefono"
                :rules="[formValidator.input.required]"
            />
            <v-text-field v-else
                    outlined required v-model="fiscalContact.telefono"
            />
        </v-col>
        <v-col cols="6" class="padding-bottom-none">
            <label for="" class="label-form ">Email</label>
            <v-text-field v-if="validRFC"
                outlined required
                v-model="fiscalContact.email"
                :rules="[formValidator.input.required]"
            />
            <v-text-field v-else
                outlined required
                v-model="fiscalContact.email"
            />
        </v-col>
        <!--<v-col cols="12" v-if="validRFC" class="padding-bottom-none">
            <label for="" class="label-form ">Uso CFDI</label>
            <v-select
                    v-model="fiscalContact.uso_cfdi"
                    :items="cfdiUses"
                    item-text="label"
                    item-value="id"
                    outlined
                    :rules="[formValidator.input.required]"
            ></v-select>
        </v-col>-->
        <v-col cols="12"  class="padding-bottom-none">
            <label for="" class="label-form ">Forma de Pago</label>
            <v-select
                outlined
                :items="formaPago"
                item-text="descripcion"
                item-value="clave"
                v-model="fiscalContact.metodo_id"
                :rules="[formValidator.input.required]"
            ></v-select>
        </v-col>
        <v-col cols="12"  class="padding-bottom-none">
            <v-checkbox
                :rules="[formValidator.input.required]"
                label="Acepto que los datos registrados son correctos y que no habrá cambios en el RFC ya que no hay cancelaciones por dichos motivos."
            ></v-checkbox>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios'
export default {
    name: "FiscalContactFormEdit",
    props: [
        'fiscalContact', 'formValidator', 'states', 'municipalities', 'neighborhoods',
        'getMunicipalitiesCatalog', 'getNeighborhoodsCatalog', 'useProcedureContact'
    ],
    data(){
        return {
            fullName: (this.fiscalContact.nombre != undefined ? this.fiscalContact.nombre : "") + " " + (this.fiscalContact.apellido_pat != undefined ? this.fiscalContact.apellido_pat : "") + " " + (this.fiscalContact.apellido_mat != undefined ? this.fiscalContact.apellido_mat : ""),
            formValid: false,
            useNameOfContact: false,
            validRFC: false,
            moralPerson: false,
            cfdiUses: [],
            regimen: [],
            formaPago: [],
            insumos: process.env.NODE_ENV === 'production' ? 'https://insumos.nl.gob.mx' : 'http://insumos.test.nl.gob.mx'
        }
    },

    watch: {
        'fiscalContact.nombre'(){
            this.fullName = (this.fiscalContact.nombre != undefined ? this.fiscalContact.nombre : "") + " " + (this.fiscalContact.apellido_pat != undefined ? this.fiscalContact.apellido_pat : "") + " " + (this.fiscalContact.apellido_mat != undefined ? this.fiscalContact.apellido_mat : "")
        },
        'fiscalContact.apellido_pat'(){
            this.fullName = (this.fiscalContact.nombre != undefined ? this.fiscalContact.nombre : "") + " " + (this.fiscalContact.apellido_pat != undefined ? this.fiscalContact.apellido_pat : "") + " " + (this.fiscalContact.apellido_mat != undefined ? this.fiscalContact.apellido_mat : "")
        },
        'fiscalContact.apellido_mat'(){
            this.fullName = (this.fiscalContact.nombre != undefined ? this.fiscalContact.nombre : "") + " " + (this.fiscalContact.apellido_pat != undefined ? this.fiscalContact.apellido_pat : "") + " " + (this.fiscalContact.apellido_mat != undefined ? this.fiscalContact.apellido_mat : "")
        }
    },

    mounted() {
        this.validateRFC()
        axios.get(this.insumos + '/api/regimen-fiscal')
        .then((result) => {
            this.regimen = result.data.datos
        })
        axios.get(this.insumos + '/api/forma-pago')
        .then((result) => {
            this.formaPago = result.data.datos
        })
        console.log(this.fiscalContact)
    },

    methods: {
        onStateSelectChange(){
            this.fiscalContact.municipio_id = ''
            this.fiscalContact.colonia = ''
            this.getMunicipalitiesCatalog(this.fiscalContact.estado_id)
        },

        onMunicipalitySelectChange(){
            this.fiscalContact.colonia = ''
            this.getNeighborhoodsCatalog(this.fiscalContact.estado_id, this.fiscalContact.municipio_id)
        },

        onChangeUseContact(){

        },

        validateRFC(){
            if(this.fiscalContact.rfc){
                this.validRFC = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(this.fiscalContact.rfc.toUpperCase())
            }

            if (this.validRFC){
                this.moralPerson = this.fiscalContact.rfc.length === 12
                this.setCFDIUses()

                if (this.moralPerson){
                    this.fiscalContact.nombre = ""
                    this.fiscalContact.apellido_pat = ""
                    this.fiscalContact.apellido_mat = ""
                }else {
                    this.fiscalContact.razon_social = ""
                }
            }
        },

        setCFDIUses(){
            let cfdiUses = [
                {"id": "G01", "label": "Adquisición de mercancias",},
                {"id": "G02", "label": "Devoluciones, descuentos o bonificaciones"},
                {"id": "G03", "label": "Gastos en general"},
                {"id": "I01", "label": "Construcciones",},
                {"id": "I02", "label": "Mobilario y equipo de oficina por inversiones"},
                {"id": "I03", "label": "Equipo de transporte"},
                {"id": "I04", "label": "Equipo de computo y accesorios"},
                {"id": "I05", "label": "Dados, troqueles, moldes, matrices y herramental"},
                {"id": "I06", "label": "Comunicaciones telefónicas"},
                {"id": "I07", "label": "Comunicaciones satelitales"},
                {"id": "I08", "label": "Otra maquinaria y equipo"},
            ]

            let moralCfdiUses = [
                {"id": "D01", "label": "Honorarios médicos, dentales y gastos hospitalarios."},
                {"id": "D02", "label": "Gastos médicos por incapacidad o discapacidad"},
                {"id": "D03", "label": "Gastos funerales."},
                {"id": "D04", "label": "Donativos."},
                {"id": "D05", "label": "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)."},
                {"id": "D06", "label": "Aportaciones voluntarias al SAR."},
                {"id": "D07", "label": "Primas por seguros de gastos médicos."},
                {"id": "D08", "label": "Gastos de transportación escolar obligatoria."},
                {"id": "D09", "label": "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones."},
                {"id": "D10", "label": "Pagos por servicios educativos (colegiaturas)"},
            ]

            let bothCfdiUses = [
                {"id": "P01", "label": "Por definir"}
            ]

            if (this.moralPerson){
                this.cfdiUses =  [...cfdiUses, ...bothCfdiUses]
            }else{
                this.cfdiUses = [...cfdiUses, ...moralCfdiUses, ...bothCfdiUses]
            }
        }
    }
}

/**/
</script>

<style scoped>
    .fiscalContactForm .v-messages {display: none}
    
    .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        /* transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1); */
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: .7rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        /* flex-grow: unset !important; */
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }    

    .padding-bottom-none{
        padding-bottom: unset !important;
    }
</style>